import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import * as action from '../action';
import * as c from '../constant';

const ApplicationInformation = ({ taxpayer }) => {
  return (
    <>
      <div className="col-12 p-3">
        <table className="transaction-table table table-borderless table-sm ">
          <tbody>
            <tr>
              <td className="text-dark" width="150">
                Last Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'last_name') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Middle Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'middle_name') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                First Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'first_name') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Extension Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'extension_name') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Gender
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'gender') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Address of applicant
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {_.get(taxpayer, 'region_name') || '--'}
                  {''}
                  {_.get(taxpayer, 'province_name') ||
                    '--'}{' '}
                  {_.get(taxpayer, 'municipality_name') || '--'}{' '}
                  {_.get(taxpayer, 'barangay_name') || '--'}{' '}
                  {_.get(taxpayer, 'street') || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Telephone No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'telephone_number') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Mobile No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'mobile_number') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Date of Birth
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {moment(_.get(taxpayer, 'birth_date')).format(
                    'MM/DD/YYYY'
                  ) || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Place of Birth
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(
                      taxpayer,
                      'place_of_birth_region_name'
                    ) || '--'
                  ).toUpperCase()}{' '}
                  {(
                    _.get(
                      taxpayer,
                      'place_of_birth_province_name'
                    ) || '--'
                  ).toUpperCase()}{' '}
                  {(
                    _.get(
                      taxpayer,
                      'place_of_birth_municipality_name'
                    ) || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Civil Status
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(taxpayer, 'civil_status') || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" width="150">
                Highest educational attainment
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {(
                    _.get(
                      taxpayer,
                      'highest_educational_attainment'
                    ) || '--'
                  ).toUpperCase()}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

ApplicationInformation.propTypes = {
  taxpayer: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = ({ api }) => ({
  taxpayer: _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`)
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ApplicationInformation);
